<template>
	<Loader v-if="loading" />
	<div v-else>
		<div class="order-view">
			<h2>{{ $t('order.overview.headline') }}</h2>

			<div class="order-box">
				<div class="content">
					<p class="product-name">{{ $t(productName) }}</p>
					<ul>
						<li>
							<p class="name">{{ $t('order.overview.orderno') }}:</p>
							<p class="info">{{ getOrderId() }}</p>
						</li>
						<li v-if="discount_price > 0">
							<p class="name">{{ $t('order.overview.normal-price') }}:</p>
							<p class="info">{{ normal_price * 0.8 | toCurrency }} DKK</p>
						</li>
						<li v-if="discount_price > 0">
							<p class="name">
								{{ $t('order.overview.discount') }}
								{{ applied_code ? '(' + applied_code + ')' : '' }}:
							</p>
							<p class="info">{{ discount_price * -0.8 | toCurrency }} DKK</p>
						</li>
						<li>
							<p class="name">{{ $t('order.overview.subtotal') }}:</p>
							<p class="info">{{ productPrice * 0.8 | toCurrency }} DKK</p>
						</li>
						<li>
							<p class="name">{{ $t('order.overview.vat') }}:</p>
							<p class="info">{{ productPrice * 0.2 | toCurrency }} DKK</p>
						</li>
					</ul>
				</div>

				<div class="bottom">
					<div class="total" style="padding-left: 30px;">
						<div class="input-container">
                            <p class="subject">{{$t('order.enter-discount-code.label')}}</p>
                        	<div class="input-inner">
								<form>
									<input type="text" v-model="discount_code" v-on:keyup.enter="applyDiscountCode()" style="margin-bottom: 0px;" autofill="off" autocomplete="false" />
								</form>
								<button :disabled="!discount_code" class="purple" v-on:click="applyDiscountCode()">
									{{ $t('order.apply-discount-code.button') }}
								</button>
							</div>
						</div>
					</div>
				</div>

				<div class="bottom">
					<div class="total" style="padding-left: 30px;">
						<p class="total-label">{{ $t('order.overview.totalcost') }}</p>
						<p class="total-cost" style="padding-right: 30px;text-align: right;">{{ productPrice | toCurrency }} DKK</p>
					</div>
				</div>
			</div>

			<label class="custom-checkbox">
		        <input type="checkbox" v-model="termsAccepted" id="accept-terms">
		        <span class="checkbox">
		            <svg xmlns="http://www.w3.org/2000/svg"  width="9.895" height="7.38" viewBox="0 0 19.79 14.76">
		                <path class="fill-checkmark" d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z" transform="translate(-1311.12 -1083.12)"/>
		            </svg>
		        </span>
		        <div class="text"><p>{{$t('register.accept-terms.text')}} </p><a target="_blank" href="https://www.rently.dk/terms/"> {{ $t('register.accept-terms.link') }}</a></div>
		    </label>
		    <button class="purple" v-on:click="next()" :disabled="!termsAccepted">
		    	<template v-if="productPrice > 0">{{$t('button.order.overview')}}</template>
		    	<template v-else>{{$t('button.order.complete-free')}}</template>
		    </button>

		</div>


	</div>
</template>

<script>
	import Vue from 'vue';

	import {mapGetters} from 'vuex';
	import Loader from '../Loader.vue';
	export default {
		props: [
			'product',
			'value',
			'params'
		],
		data: () => ({
			loading: false,
			order: {},
			productName: '',
			productPrice: 0,
			termsAccepted: false,
			discount_price: 0,
			normal_price: 0,
			discount_code: '',
			applied_code: ''
		}),
		components: {
			Loader
		},
		computed: {
			...mapGetters([
				'getToken'
			]),
			orderNo: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit('input', value);
				}
			}
		},
		methods: {
			next() {
				this.$emit('next', {
					free: this.productPrice == 0 ? true : false
				});
			},
			getOrderId() {
				return this.order.id;
			},
			applyDiscountCode() {
				this.createOrder();
			},
			createOrder() {
				this.loading = true;
				axios({
					method: 'POST',
					url: window.config.apiUrl + 'api/order',
					cancelToken: window.AuthorizationCancelSource.token,
            		data: {
            			productId: this.product,
            			params: this.params,
            			discount_code: this.discount_code
            		}
				}).then(response => {
					this.loading = false;
					this.order = response.data.order;
					this.productName = response.data.product.name;
					this.productPrice = response.data.product.price;
					this.orderNo = this.getOrderId();
					this.discount_price = response.data.product.discount_price;
					this.normal_price = response.data.product.normal_price;
					this.applied_code = response.data.discount_code;
				}).finally((e) => {
					this.loading = false;
				});
			}
		},
		mounted() {
			this.createOrder();
		}
	}
</script>
